// src/components/ForceReloadLink.tsx
import { Link, useLocation } from 'react-router-dom';

interface ForceReloadLinkProps {
  to: string;
  children: React.ReactNode;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
}

export function ForceReloadLink({ to, children, className, onClick }: ForceReloadLinkProps) {
  const location = useLocation();
  
  // Check if the link destination matches the current path
  const isSamePath = location.pathname === to;
  
  const handleClick = (e: React.MouseEvent) => {
    // Execute custom onClick handler if provided
    if (onClick) {
      onClick(e);
      // If event was prevented by custom handler, respect that
      if (e.defaultPrevented) return;
    }
    
    // Force reload for same path navigation
    if (isSamePath) {
      e.preventDefault(); // Prevent default Link behavior
      window.location.href = to; // Force a full page reload to this URL
    }
    // Otherwise, let the Link component handle navigation normally
  };
  
  return (
    <Link to={to} onClick={handleClick} className={className}>
      {children}
    </Link>
  );
}